// extracted by mini-css-extract-plugin
module.exports = {"main":"Title_main__2g0zD","skeleton":"Title_skeleton__tq4O4"};